'use client'

import React, { type ReactNode, useEffect, useRef } from 'react'

export interface MenuListProps {
  children: ReactNode
  className?: string
  tabIndex?: number
  autoFocus?: boolean
  autoFocusItem?: boolean
  disabledItemsFocusable?: boolean
  disableListWrap?: boolean
  variant?: 'menu' | 'selectedMenu'
}

export const MenuList: React.FC<MenuListProps> = ({
  children,
  className = '',
  tabIndex,
  autoFocus = false,
  autoFocusItem = false,
  ...props
}) => {
  const menuListRef = useRef<HTMLUListElement>(null)

  useEffect(() => {
    if (autoFocus && menuListRef.current) {
      menuListRef.current.focus()
    }
  }, [autoFocus])

  useEffect(() => {
    if (autoFocusItem && menuListRef.current) {
      const firstMenuItem = menuListRef.current.querySelector('[role="menuitem"]') as HTMLElement
      if (firstMenuItem) {
        firstMenuItem.focus()
      }
    }
  }, [autoFocusItem])

  return (
    <ul
      ref={menuListRef}
      className={`list-none m-0 p-0 outline-hidden ${className}`}
      role="menu"
      tabIndex={tabIndex}
      {...props}
    >
      {children}
    </ul>
  )
}

export default MenuList
